import Modal from 'LuxKit/Modal/Modal'
import Table from 'LuxKit/Tables/Table'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React from 'react'

function LoyaltyLandingPageMovingTiersModal() {
  return <Modal size="S" title="Moving through the tiers">
    <Group direction="vertical" gap={16}>
      <BodyText variant="medium">
        The below is what you’ll need to achieve within your calendar year to progress to the next tier or retain your current tier.
      </BodyText>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                Tier
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                Status Credits
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                Number of nights
              </BodyText>
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                Silver
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                200
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                10
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                Gold
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                600
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                20
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                Platinum
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                1,000
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                30
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
        </TableBody>
      </Table>
    </Group>
  </Modal>
}

export default LoyaltyLandingPageMovingTiersModal
